import offlineTicketsTemplate from './offlineTickets.html';

export default angular.module('eventix.dashboard.import', [])
    .config(ModuleConfig)
    .component('offlineTicketsPage', {
        templateUrl: offlineTicketsTemplate,
        controller: OfflineTicketsPageController,
        bindings: {
            company: '<',
        },
    }).name;

function OfflineTicketsPageController(Locales) {
    const $ctrl = this;

    $ctrl.$onInit = function() {
        $ctrl.newDashboardRedirect = NEW_DASHBOARD_ROOT + 'guestlist-classic?legacy=true&locale=' + Locales.selected + '&company=' + $ctrl.company.guid;
    };
}

function ModuleConfig($stateProvider) {
    $stateProvider.state('eventix.dashboard.offlineTickets', {
        url: '/guestlist',
        views: {
            'dashboard@eventix.dashboard': {
                component: 'offlineTicketsPage',
                bindings: {
                    company: 'company',
                },
            },
        },
        data: {
            requiredRoles: ['Event Manager'],
            crumb: 'common.menu.guestlist.offlineOrders',
        },
    });
}
